import { FormSelectDataType, getContactFieldTitle, Hint } from '@systemeio/ui'
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields'
import { SubstituteInterface } from 'shared/components/dashboard-mail-editor/components/substitutes-block'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useSubstitutes = (additionalSubstitutes: SubstituteInterface[] = []) => {
  const { t } = useLocoTranslation()

  const { fields: substitutes } = useContactFields()

  const additionalSubstitutionData: FormSelectDataType<string>[] = additionalSubstitutes.map(
    el => ({
      id: `{${el.slug}}`,
      caption: el.name,
    }),
  )

  const contactSubstitutionData: FormSelectDataType<string>[] = (substitutes?.items ?? []).map(
    el => ({
      id: `{${el.slug}}`,
      caption: getContactFieldTitle(el),
    }),
  )

  const affiliateSubstitutionData: FormSelectDataType<string>[] = [
    { caption: t('dashboard.email.contact_affiliate_id'), id: '{affiliate_id}' },
    {
      caption: t('dashboard.email.contact_affiliate_url'),
      customCaption: (
        <Hint
          label={
            <TransLoco
              t={t}
              i18nKey={'dashboard.email.clickable_url_description'}
              components={{
                a: <span className={'block pl-3'} />,
                b: <b />,
              }}
            />
          }
        >
          {t('dashboard.email.contact_affiliate_url')}
        </Hint>
      ),
      id: '{affiliate_dashboard}',
    },
  ]

  const substitutionData = [
    ...additionalSubstitutionData,
    ...contactSubstitutionData,
    ...affiliateSubstitutionData,
  ]

  const isReady = !!substitutes

  return {
    substitutionData,
    isReady,
  }
}
